/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formemail_Validation1Inputs */

const ja_contact_formemail_validation1 = /** @type {(inputs: Contact_Formemail_Validation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有効なメール アドレスを入力してください`)
};

const en_contact_formemail_validation1 = /** @type {(inputs: Contact_Formemail_Validation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please input valid email address`)
};

/**
* | output |
* | --- |
* | "Please input valid email address" |
*
* @param {Contact_Formemail_Validation1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formemail_validation1 = /** @type {((inputs?: Contact_Formemail_Validation1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formemail_Validation1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formemail_validation1(inputs)
	return en_contact_formemail_validation1(inputs)
});
export { contact_formemail_validation1 as "contact_formEmail_validation" }